'use client'
import { Button } from '@/src/components/ui/button'
import Image from 'next/image'
import Link from 'next/link'
import React, { useState } from 'react'
import { Autoplay, EffectFade } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/autoplay'

// Desktop images
const desktopImages = [
  '/images/hero/desktop/carousel-desktop-1.jpg',
  '/images/hero/desktop/carousel-desktop-2.jpg',
  '/images/hero/desktop/carousel-desktop-3.jpg',
  '/images/hero/desktop/carousel-desktop-4.jpg',
  '/images/hero/desktop/carousel-desktop-5.jpg',
]

// Mobile images
const mobileImages = [
  '/images/hero/mobile/carousel-mobile-1.jpg',
  '/images/hero/mobile/carousel-mobile-2.jpg',
  '/images/hero/mobile/carousel-mobile-3.jpg',
  '/images/hero/mobile/carousel-mobile-4.jpg',
  '/images/hero/mobile/carousel-mobile-5.jpg',
  '/images/hero/mobile/carousel-mobile-6.jpg',
]

function Hero() {
  const [swiperInitialized, setSwiperInitialized] = useState(false)

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image - Always visible */}
      <div className={`absolute inset-0 z-0 insivible md:visible ${swiperInitialized ? 'md:hidden' : ''}`}>
        <Image
          src="/images/hero/desktop/carousel-desktop-1.jpg"
          alt="Hot dog background"
          fill
          priority
          className="object-cover brightness-50"
        />
      </div>

      <div className={`absolute inset-0 z-0 visible md:invisible ${swiperInitialized ? 'hidden' : ''}`}>
        <Image
          src="/images/hero/mobile/carousel-mobile-1.jpg"
          alt="Hot dog background"
          fill
          priority
          className="object-cover brightness-50"
        />
      </div>

      {/* Desktop Carousel - Hidden on mobile */}
      <div className="absolute inset-0 z-0 hidden md:block">
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          className="w-full h-full"
          onInit={() => setSwiperInitialized(true)}
          style={{ visibility: swiperInitialized ? 'visible' : 'hidden' }}
        >
          {desktopImages.map((image, index) => (
            <SwiperSlide key={`desktop-${index}`} className={index === 0 ? '' : 'opacity-0'}>
              <div className="w-full h-full">
                <Image
                  src={image}
                  alt={`Sr. Perrito slide ${index + 1}`}
                  fill
                  className="object-cover brightness-50"
                  priority={index === 0}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Mobile Carousel - Hidden on desktop */}
      <div className="absolute inset-0 z-0 md:hidden">
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          className="w-full h-full"
          onInit={() => setSwiperInitialized(true)}
          style={{ visibility: swiperInitialized ? 'visible' : 'hidden' }}
        >
          {mobileImages.map((image, index) => (
            <SwiperSlide key={`mobile-${index}`} className={index === 0 ? '' : 'opacity-0'}>
              <div className="w-full h-full">
                <Image
                  src={image}
                  alt={`Sr. Perrito slide ${index + 1}`}
                  fill
                  className="object-cover brightness-50"
                  priority={index === 0}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Content */}
      <div className="container relative z-10 px-4 py-32 md:py-40 text-center">
        {/* Decorative Pattern Top */}
        <div className="absolute top-0 left-0 right-0 h-4 bg-[url('/images/checkered-pattern.png')] bg-repeat-x"></div>

        <div className="max-w-4xl mx-auto">
          {/* Logo Animation */}
          <div className="relative h-48 w-48 mx-auto mb-6 animate-float">
            <Image
              src="/images/dog-icon.svg"
              alt="Sr.Perrito Icon"
              fill
              className="object-contain"
            />
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-srperrito-cream mb-4 font-serif">
            Perritos calientes Gourmet en Córdoba
          </h1>

          <p className="text-xl md:text-2xl text-srperrito-cream/90 mb-8 max-w-2xl mx-auto">
            Combinaciones únicas cada día con ingredientes frescos de alta calidad
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link href="/menu">
              <Button variant="cream" size="xl" className="animate-bounce">
                Ver Menú
              </Button>
            </Link>
          </div>
        </div>

        {/* Decorative Pattern Bottom */}
        <div className="absolute bottom-0 left-0 right-0 h-4 bg-[url('/images/checkered-pattern.png')] bg-repeat-x"></div>
      </div>
    </section>
  )
}

export default Hero
